export const useVideo3 = props => {
	const { metaData } = props

	return [
		{
			video: metaData.video?.metaValue,
		},
	]
}
